export const detailCode = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    group: { en: 'Group', ko: '그룹코드', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    code: { en: 'Code', ko: '코드', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
  info: {
    group: { en: 'Group', ko: '그룹코드', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    code: { en: 'Code', ko: '코드', fr: '' },
    description: { en: 'Description', ko: '비고', fr: '' },
  },
  select: {
    group: { en: 'Select Group Code', ko: '그룹코드 선택', fr: '' },
  },
};
